import { render, staticRenderFns } from "./participants-number.vue?vue&type=template&id=b2e50c7a&scoped=true&"
import script from "./participants-number.vue?vue&type=script&lang=js&"
export * from "./participants-number.vue?vue&type=script&lang=js&"
import style0 from "./participants-number.vue?vue&type=style&index=0&id=b2e50c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e50c7a",
  null
  
)

export default component.exports